import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { SxProps, Theme } from '@mui/system';

interface SectionCardPropsBase {
	width: string;
	height: string;
	maxWidth: string;
	minWidth: string;
	maxHeight: string;
	padding: string;
	margin: string;
	display: string;
	justifyContent: string;
	boxOverflowHidden: boolean;
	noscroll: boolean | undefined;
	overflowY: string | undefined;
	children: ReactNode;
}

type SectionCardProps = Partial<SectionCardPropsBase>;

const SectionCard = (props: SectionCardProps) => {
	const resolvedOverflowY =
		props.noscroll !== undefined ? (props.noscroll ? 'hidden' : 'scroll') : props.overflowY;

	return (
		<Box
			sx={{
				width: props?.width || '50%',
				overflow: props?.boxOverflowHidden ? 'hidden' : undefined,
				maxWidth: props?.maxWidth,
				minWidth: props?.minWidth
			}}
		>
			<Card
				data-testid={'sectionCard-container'}
				sx={
					{
						display: props?.display,
						justifyContent: props?.justifyContent,
						width: '100%',
						height: props?.height || '502px',
						padding: props?.padding || '32px 30px 0px 30px',
						overflowY: resolvedOverflowY || undefined,
						margin: props?.margin || '0px',
						position: 'relative',
						maxHeight: props?.maxHeight || undefined
					} as SxProps<Theme>
				}
				variant="outlined"
			>
				{props?.children}
			</Card>
		</Box>
	);
};

export default SectionCard;
